import * as React from "react"
import styled from "styled-components"
import { theme } from "../../theme"
import { RadioButtonActive, RadioButtonPassive } from "../icons/RadioButtonIcons"

interface Props {
  checked?: boolean
  onChange?: () => void
  disabled?: boolean
}

const ButtonContainer = styled.div<{ disabled?: boolean }>`
  //width: 24px;
  //height: 24px;
  padding: 0;
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};

  :hover {
    opacity: ${(props) => (props.disabled ? 1 : 0.7)};
  }
`

const RadioButton: React.FunctionComponent<Props> = ({ checked, onChange, disabled }) => {
  return (
    <ButtonContainer disabled={disabled} onClick={disabled ? undefined : onChange}>
      {checked ? (
        <RadioButtonActive color={disabled ? theme.colors.greyDisabled : theme.colors.greyDark} />
      ) : (
        <RadioButtonPassive color={disabled ? theme.colors.greyDisabled : theme.colors.greyDark} />
      )}
    </ButtonContainer>
  )
}

export default RadioButton
